'use strict';
import React from 'react';
import classNames from 'classnames';

/**
 * Simple divider with margins to separate content.
 *
 * Usage:
 *
 * ```Javascript
 * <Divider />
 * ```
 *
 * @extends {React.Component}
 * @property {Boolean} secondary Renders the Divider line color as secondary.
 */
class Divider extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      'Divider': true,
      'Divider--secondary': this.props.secondary
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <hr className={this.getClassName()}/>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Divider component
 */
Divider.propTypes = {
  secondary: React.PropTypes.bool
};

Divider.defaultProps = {
  secondary: false
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/divider.jsx